import React from "react";
import AboutFull from "../AboutFull";

function About() {
	return <AboutFull />;
}

export default About;
